const getSiblings = function (el) {
  // Setup siblings array and get the first sibling
  var siblings = [];
  var sibling = el.parentNode.firstChild;

  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== el) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling
  }

  return siblings;
};

const index = function (el) {
  if (!el) return "!";
  var i = 0;
  while (el = el.previousElementSibling) {
    i++;
  }
  return i;
}

function setCharAt(str,index,chr) {
  if(index > str.length-1) return str;
  return str.substr(0,index) + chr + str.substr(index+1);
}